import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useTenant } from 'src/hooks/api';
import { useTenantAuthorization } from 'src/modules/TenantManagement/Tenant';
import { StandardRouteParams } from 'src/types';

export const DynamicTenantBreadcrumb = () => {
  const { t } = useTranslation(['common']);

  const { tenantId } = useParams<StandardRouteParams>();

  const { isError: isErrorEvaluations, isPending: isPendingEvaluations } =
    useTenantAuthorization(tenantId);

  const { data, error, isPending } = useTenant(tenantId, {
    // Only fetch once the user is confirmed authorized
    enabled: !isPendingEvaluations && !isErrorEvaluations,
  });

  if (isPending || isPendingEvaluations) {
    return t('common:loadingFeedback.loading');
  }

  if (error || isErrorEvaluations) {
    return t('common:error.error');
  }

  return data.name;
};
